//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { ChangeColMixin } from '@/mixins/ChangeColMixin';
import { downloadFile } from '@/api/manage';
import moment from 'moment';
export default {
  name: 'waterData',
  data: function data() {
    var _this = this;

    return {
      url: '/st/api/realtime',
      cols: [{
        title: '监测时间',
        align: 'center',
        width: 150,
        dataIndex: 'dataTime',
        colName: 'data_time'
      }, {
        title: '水质标准',
        align: 'center',
        width: 150,
        customRender: function customRender(text, record, index) {
          return _this.renderStatus(record);
        }
      }]
    };
  },
  mixins: [GetSiteIdMixin, ChangeColMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.queryParam.id = ids[1];
        this.queryParam.type = '1';
        this.loadData();
      } else {
        this.queryParam.id = ids[1];
        this.queryParam.type = '2';
        this.loadData();
      }
    }
  },
  methods: {
    handleExportXls: function handleExportXls(s) {
      var url = '/st21/cn2061/exportXls';
      downloadFile(s, url, this.queryParam);
    }
  }
};